export enum ErrorCodes {
  INVALID_CREDENTIALS = 'invalid-credentials',
}
